const updateItems = [
  { date: '07-28', title: '《星之妖精》第158话更新', tag: '新章节', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '《小妖精日常》第42话暖心上线', tag: '萌系推荐', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '《魔导师传说》突破200话纪念活动', tag: '里程碑', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '《暗夜猎魔人》新角色登场预告', tag: '剧情预告', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-26', title: '《异世界食堂》番外篇两连更', tag: '特别更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '平台新增5部奇幻新作上线通知', tag: '新作入驻', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-25', title: '《精灵之森》动画化企划进行中', tag: '重磅消息', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '萌系漫画专区阅读体验全面升级', tag: '平台优化', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          妖精漫画网每日更新动态，追更快讯一手掌握
        </p>

        <div className="relative pl-8 md:pl-10 before:absolute before:left-[15px] md:before:left-[19px] before:top-2 before:bottom-2 before:w-px before:bg-background-300">
          {updateItems.map((item, i) => (
            <div key={i} className="relative mb-6 last:mb-0">
              <div className="absolute left-[-2rem] md:left-[-2.5rem] top-1 w-3 h-3 rounded-full bg-primary-400 ring-4 ring-background-100"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-xs font-mono text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                  {item.date}
                </span>
                <span className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</span>
                <span className={`px-2 py-0.5 rounded-full text-xs whitespace-nowrap w-fit ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}